import { useTranslation } from 'react-i18next'

import { ClockCounterClockwiseIcon } from '@phosphor-icons/react'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreByDefaultConfiguration = ({ stores, value, onChange }) => {
  const { t } = useTranslation()

  const storeOptions = [{ name: t('Última tienda visitada'), id: 'null' }, ...stores]

  return (
    <Styles.MainContainer>
      <Text type="titleM">{t('Tienda por defecto')}</Text>
      <Text type="bodyMRegular">
        {t('Seleccione la tienda que se seleccionará por defecto para la navegar cuando inicies sesión.')}
      </Text>
      <ComboBox
        label={t('Tienda')}
        value={value}
        handleChange={e => onChange(e.target.value)}
        menuItems={storeOptions.map(s => ({
          label: (
            <Styles.StoreLabelContainer>
              {s?.id === 'null' ? (
                <ClockCounterClockwiseIcon size={24} />
              ) : (
                <Styles.StoreImage
                  src={s?.portals?.[0]?.theme?.returns_favicon_url || s?.portals?.[0]?.theme?.logo_url}
                />
              )}
              <Styles.StoreContent>
                {s.name}
                {s.domain && <Text type="bodySRegular">{s.domain}</Text>}
              </Styles.StoreContent>
            </Styles.StoreLabelContainer>
          ),
          value: s.id,
        }))}
      />
    </Styles.MainContainer>
  )
}

export default StoreByDefaultConfiguration
